import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhengyan",
  "use": "icon-zhengyan-usage",
  "viewBox": "0 0 1472 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1472 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-zhengyan\"><defs><style type=\"text/css\"></style></defs><path d=\"M743.68 160c-269.952 0-509.248 270.08-576.128 352.896C234.432 593.92 473.728 864 743.68 864c269.824 0 509.12-270.08 576-352.896-66.88-80.96-306.176-351.04-576-351.04z m0 832c-317.76 0-578.368-280.064-675.712-400.448a125.824 125.824 0 0 1 0.512-159.744C165.312 312 425.92 32 743.68 32c317.568 0 578.24 280 675.52 400.384a125.44 125.44 0 0 1-0.512 159.744C1321.92 711.936 1061.248 992 743.68 992z m0-608c-70.656 0-128 57.344-128 128 0 70.528 57.344 128 128 128 70.528 0 128-57.472 128-128a128.064 128.064 0 0 0-128-128z m0 384c-141.248 0-256-114.816-256-256a256.256 256.256 0 0 1 256-256c141.12 0 256 114.88 256 256 0 141.184-114.88 256-256 256z\" fill=\"#000000\" p-id=\"10744\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zhengyan.svg
// module id = lU9u
// module chunks = 4